import { makeStyles } from '@material-ui/core/styles';
import { colors } from 'styles/colors';
import fonts from 'styles/fonts';
import * as spacing from 'styles/spacing';

const useStyles = makeStyles({
  stackedBarChart: {
    display: 'flex',
    justifyContent: 'center',
    boxShadow: 'none',
    width: '100%',
    '& > div': {
      paddingTop: '0px',
      width: '100%',
      '& #center-container > div > div > div > svg > g > text': {
        fontSize: `${spacing.default.xxsmall}`,
        color: colors.chartLegend,
        fontWeight: fonts.weights.normal,
        letterSpacing: '0.4px',
        lineHeight: '16px',
        marginLeft: '8px',
      },
    },
  },
  labelContainer: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    paddingBottom: '0',
    '& > li': {
      width: 'auto',
    },
  },
  labelText: {
    '& > span': {
      whiteSpace: 'nowrap',
      color: colors.chartLegend,
      fontWeight: fonts.weights.normal,
      fontSize: fonts.sizes.medium,
      letterSpacing: '0.25px',
      lineHeight: '20px',
    },
  },
  labelMarker: {
    display: 'none',
  },
  barLabel: {
    color: colors.chartLegend,
    fontWeight: fonts.weights.medium,
    fontSize: fonts.sizes.xxsmall,
    letterSpacing: '1.5px',
    lineHeight: '16px',
    marginLeft: '8px',
  },
});

export default useStyles;
